/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

function configs(labels, datasets, units) {
  let datasetsArray;
  if (!Array.isArray(datasets)) {
    datasetsArray = [datasets];
  } else {
    datasetsArray = datasets;
  }
  datasetsArray = datasetsArray.map((i) => ({
    label: i.label,
    tension: 0.4,
    borderWidth: 0,
    borderRadius: 4,
    borderSkipped: false,
    backgroundColor: i.backgroundColor,
    data: i.data,
    maxBarThickness: 60,
  }));
  return {
    data: {
      labels,
      datasets: datasetsArray,
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        tooltip: {
          callbacks: {
            label: (tooltipItem) => {
              const label = tooltipItem.dataset.label ? `${tooltipItem.dataset.label}: ` : "";
              const value = tooltipItem.parsed.y.toFixed(5);
              return `${label}${value}${units.y ? ` ${units.y}` : ""}`;
            },
          },
        },
        legend: {
          display: false,
        },
        datalabels: {
          display: false,
        },
      },
      interaction: {
        intersect: false,
        mode: "index",
      },
      scales: {
        y: {
          title: {
            display: Boolean(units.y),
            text: units.y,
            color: "#fff",
          },
          grid: {
            drawBorder: false,
            display: true,
            drawOnChartArea: true,
            drawTicks: false,
            borderDash: [5, 5],
            color: "rgba(255, 255, 255, .2)",
          },
          ticks: {
            suggestedMin: 0,
            suggestedMax: 500,
            beginAtZero: true,
            padding: 10,
            font: {
              size: 14,
              weight: 300,
              family: "Roboto",
              style: "normal",
              lineHeight: 2,
            },
            color: "#fff",
          },
        },
        x: {
          title: {
            display: Boolean(units.x),
            text: units.x,
            color: "#fff",
          },
          grid: {
            drawBorder: false,
            display: true,
            drawOnChartArea: true,
            drawTicks: false,
            borderDash: [5, 5],
            color: "rgba(255, 255, 255, .2)",
          },
          ticks: {
            display: true,
            color: "#f8f9fa",
            padding: 10,
            font: {
              size: 14,
              weight: 300,
              family: "Roboto",
              style: "normal",
              lineHeight: 2,
            },
          },
        },
      },
    },
  };
}

export default configs;
